import { LoadingSpinnerProps } from '../../../types';

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  color = 'emerald',
  className = ''
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };
  
  const colorClasses = {
    emerald: 'border-emerald-500',
    blue: 'border-blue-500',
    gray: 'border-gray-500',
    white: 'border-white',
    red: 'border-red-500',
    yellow: 'border-yellow-500',
    green: 'border-green-500'
  };
  
  const spinnerClasses = `animate-spin rounded-full border-b-2 ${sizeClasses[size]} ${colorClasses[color]} ${className}`;

  return (
    <div className={spinnerClasses} />
  );
};

export default LoadingSpinner; 